import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { SectionMessages } from '../../../../components/InfoBlock';
import { useTranslation } from 'react-i18next';

PassportInfo.propTypes = {};

function PassportInfo({ passportInfo }) {
  const { sections } = passportInfo || {};
  const { t } = useTranslation();
  if (!passportInfo || !sections || !sections.length) {
    return <Typography>{t('noInformation')}</Typography>;
  }

  const filteredSections = sections.filter(
    (section) => section.sectionName === 'Warning:'
  );

  if (!filteredSections || !filteredSections.length) {
    return <Typography>{t('noInformation')}</Typography>;
  }

  return (
    <>
      {filteredSections &&
        filteredSections.map((section, index) => (
          <SectionMessages section={section} key={index} />
        ))}
    </>
  );
}

export default PassportInfo;
